import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { useDevice } from 'app/agriculture/queries/devices/useDevice';
import { useMemo } from 'react';
import { StatusMessage } from 'app/agriculture/routes/Devices/utils/status/types';
import { brandConfig } from 'app/agriculture/queries/snapshots/config/brandConfig';

export function useHeartbeatStatus({
    deviceId,
    cursorTimeOverride,
}: {
    deviceId: string;
    cursorTimeOverride?: Date;
}): StatusMessage {
    const device = useDevice({ deviceId });

    const heartbeatSnapshot = useSnapshot({
        parentId: deviceId,
        snapshotType: brandConfig[device.brand].offlineLatestSnapshotType,
        shelfLife: brandConfig[device.brand].snapshotShelfLife,
        cursorTimeOverride,
    });

    return useMemo(() => {
        if (heartbeatSnapshot == null) {
            return {
                messages: ['Device is offline'],
                status: device.deviceType === 'Personal Locator Beacon' ? 'expectedError' : 'error',
            };
        }
        return { messages: [], status: 'success' };
    }, [device, heartbeatSnapshot]);
}
